import {
  createStorageConsentRecord,
  readBrowserStorageConsent,
  subscribeStorageConsent,
  synchronizeStorageConsent,
  writeBrowserStorageConsent,
  STORAGE_CONSENT_EVENT,
  STORAGE_CONSENT_KEY,
  STORAGE_CONSENT_VERSION,
} from '@vectormethods/storage-consent';
import type { StorageConsentRecord, StorageConsentSelection } from '@vectormethods/storage-consent';
import { revokeToltRuntime } from '@vectormethods/storage-consent/tolt-runtime';

export { STORAGE_CONSENT_KEY, STORAGE_CONSENT_VERSION, STORAGE_CONSENT_EVENT, subscribeStorageConsent };
export type { StorageConsentRecord, StorageConsentSelection };
export const OPEN_STORAGE_SETTINGS_EVENT = 'vectormethods:open-storage-settings';

export interface StorageConsentEventDetail {
  consent: StorageConsentRecord;
  optionalStorageAllowed: boolean;
}

function mirrorLegacyChoices(consent: StorageConsentRecord): void {
  try {
    const allowed = consent.analytics || consent.marketing;
    window.localStorage.setItem('vectormethods_storage_choice', allowed ? 'accepted' : 'necessary');
    window.localStorage.setItem('vectormethods_optional_storage_consent', allowed ? 'true' : 'false');
  } catch {
    // Output-only compatibility mirrors never authorize tracking.
  }
}

export function readStorageConsent(): StorageConsentRecord | null {
  const consent = readBrowserStorageConsent();
  if (consent) mirrorLegacyChoices(consent);
  return consent;
}

export function hasAffiliateMarketingConsent(): boolean {
  return synchronizeStorageConsent()?.marketing === true;
}

export function saveStorageConsent(
  selection: StorageConsentSelection,
  updatedAt = new Date().toISOString(),
): StorageConsentRecord {
  const consent = createStorageConsentRecord(selection, updatedAt);
  mirrorLegacyChoices(consent);
  writeBrowserStorageConsent(consent);
  if (!consent.marketing) revokeToltRuntime({ reloadIfStarted: true });
  return consent;
}

export function openStorageSettings(): void {
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(OPEN_STORAGE_SETTINGS_EVENT));
}

export function isValidAffiliateReferral(value: string | null | undefined): value is string {
  return typeof value === 'string' && /^[A-Za-z0-9_-]{1,128}$/.test(value);
}
